import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GlobalModule } from 'src/app/global/global.module';
import { CalsoftMockApiModule } from 'src/app/global/mock-api';
import { CalsoftConfigModule } from 'src/app/global/services/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './core/config/app.config';
import { CoreModule } from './core/core.module';
import { mockDataServices } from './data/mock';
import { LayoutModule } from './layout/layout.module';
import { DirectiveModule } from './shared/directive/directive.module';
import { RestrictionPopUpModule } from './shared/restriction-pop-up/restriction-pop-up.module';
import { OrderReceivedPopupModule } from './shared/order-received-popup/order-received-popup.module';
import { ReminderPopupModule } from './shared/reminder-popup/reminder-popup.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { GeminichatComponent } from './geminichat/geminichat.component';
import { InsertClauseDialogComponent } from './pages/contract-template/insert-clause-dialog/insert-clause-dialog.component';
import { ClauseEditorComponent } from './pages/contract-template/insert-clause-dialog/clause-editor/clause-editor.component';
import { FormsModule } from '@angular/forms';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';;
import { DocEditorModule } from './shared/doc-editor/doc-editor.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LoaderModule } from './pages/loader/loader.module';
import { RenewalModule } from './pages/renewal/renewal.module';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AuthService } from './services/auth.service';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { ConfigGoogleService } from './config-google.service';
import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider, GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import { MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { OAuthSettings } from './shared/outlook-calender/outlook-calender.module';
import { StepGuideModule } from './shared/step-guide/step-guide.module';
import { TourCoreModule } from './modules/tour/tour-core.module';
let msalInstance: IPublicClientApplication | undefined = undefined;

export function MSALInstanceFactory(): IPublicClientApplication {
    msalInstance =
        msalInstance ??
        new PublicClientApplication({
            auth: {
                clientId: OAuthSettings.appId,
                redirectUri: OAuthSettings.redirectUri,
                postLogoutRedirectUri: OAuthSettings.redirectUri,
            },
            cache: {
                cacheLocation: BrowserCacheLocation.LocalStorage,
            },
        });

    return msalInstance;
}

export function initializeGoogleConfig(configService: ConfigGoogleService) {
    return () => configService.loadAppConfig();
}

export function provideSocialAuthConfig(configService: ConfigGoogleService): SocialAuthServiceConfig {
    return {
        autoLogin: false,
        providers: [
            {
                id: GoogleLoginProvider.PROVIDER_ID,
                provider: new GoogleLoginProvider(
                    configService.googleClientId // <-- Using the dynamic ID from the service
                )
            },
        ],
        onError: (err) => {
            console.error(err);
        },
    };
}

// export function MSALInstanceFactory() {
//   return new PublicClientApplication({
//     auth: {
//       clientId: 'e62d7596-27f2-4330-aa3b-cf01a0fc45d6', // 👈 Replace
//       authority: 'https://login.microsoftonline.com/common',
//       redirectUri: 'http://localhost:4206' // 👈 Replace
//     },
//     cache: {
//       cacheLocation: 'localStorage',
//       storeAuthStateInCookie: true
//     }
//   });
// }
@NgModule({
    declarations: [
        AppComponent,
        GeminichatComponent,
        InsertClauseDialogComponent,
        ClauseEditorComponent

    ],
    entryComponents: [
        // dialog components
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        DirectiveModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatSnackBarModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        FormsModule,
        CustomFlexLayoutModule,
        DocEditorModule,
        // Calsoft & Calsoft Mock API
        GlobalModule,
        CalsoftConfigModule.forRoot(appConfig),
        CalsoftMockApiModule.forRoot(mockDataServices),

        // Core
        CoreModule,

        // Layout
        LayoutModule,
        RestrictionPopUpModule,
        OrderReceivedPopupModule,
        ReminderPopupModule,
        DragDropModule,
        LoaderModule,
        RenewalModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireMessagingModule,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideMessaging(() => getMessaging()),
        HttpClientModule,
        MarkdownModule.forRoot({ loader: HttpClient }),
        SocialLoginModule,
        GoogleSigninButtonModule,
        StepGuideModule,
        TourCoreModule

    ],
    providers: [
        AuthService,

        // {
        //     provide: LocationStrategy,
        //     useClass: HashLocationStrategy,

        //   },
        ConfigGoogleService, // <-- Add the service itself as a provider

        // Provider to initialize the config service on app startup
        {
            provide: APP_INITIALIZER,
            useFactory: initializeGoogleConfig,
            deps: [ConfigGoogleService],
            multi: true
        },

        // Provider that uses the loaded config for the social login library
        {
            provide: 'SocialAuthServiceConfig',
            useFactory: provideSocialAuthConfig,
            deps: [ConfigGoogleService]
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
        },
        MsalService,
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
